import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}`;

export const dataCollectionService = {
    saveCollectionData,
    searchHandle
};


function saveCollectionData(params) {
  return fetchWrapper.post(`${baseUrl}/manual/instagram`, params);
}

function searchHandle(params) {
  return fetchWrapper.post(`${baseUrl}/bizdisc/instagram`, params);
}







